// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Header_wrapper__PJAKW","content":"Header_content__ENXbo"};